function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#e0c1a4;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-18,.cls-19,.cls-20,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-4{fill:#987f51;}.cls-5{fill:#997659;}.cls-6{fill:#b28b67;}.cls-7{fill:#f8e260;}.cls-8{fill:#eb5241;}.cls-9{fill:#dde3e9;}.cls-11{clip-path:url(#clip-path-2);}.cls-12{fill:#191847;}.cls-13{fill:#d9bcaa;}.cls-14{fill:#b14196;}.cls-15{fill:#afb9c5;}.cls-16{fill:#c5cfd6;}.cls-17{clip-path:url(#clip-path-3);}.cls-18{fill:#bbd737;}.cls-19{fill:#325ca7;}.cls-20{fill:#797979;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: -2.03,
  width: 463.98,
  height: 383.94
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 38.95,
  y: 95.47,
  width: 407,
  height: 288.47
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 229.95,
  y: 132.94,
  width: 245.36,
  height: 251
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Family"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "humaaans_standing-19",
  "data-name": "humaaans standing-19"
}, /*#__PURE__*/React.createElement("g", {
  id: "humaaan-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Head_Front_Short-Beard",
  "data-name": "Head Front Short-Beard"
}, /*#__PURE__*/React.createElement("g", {
  id: "Head"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  className: "cls-3",
  d: "M71.32,59.92c-8.21-5.6-14.83-13.38-16.8-23.56C48.84,7,91,2.53,102.72,15S123.42,64.46,114,69.78c-3.78,2.13-13.09,1.9-23.29-1L106.55,106,74,114.72Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Hair",
  className: "cls-4",
  d: "M82.62,32.23Q91.41,57.55,99.43,55.4c8-2.15,13.48-9,17-10,2.57-.69,2.85,2.65,1.78,5.47-.88,2.32-7.22,6-6.41,9.05s5.59-.77,6.07,1c.79,3,3.23,8.28-2,9.67S95.06,74.13,90.41,67.1Q86,60.35,79,37.05A8.42,8.42,0,0,0,72,47.5h0a8.23,8.23,0,0,0,4,5.12c-1.18,3.14-2.56,6.46-4.21,10-10.54-3-22.83-18.29-18-35.88.46-8.1,6.26-12.26,12.33-15.86A24.59,24.59,0,0,1,81.27,5.54c9.35-1.68,18.25-1.1,21-.08C104.57,14,103.58,17,89.2,20.64,86.17,23.43,84.32,27.32,82.62,32.23Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Bottom_Standing_Baggy-Pants",
  "data-name": "Bottom Standing Baggy-Pants"
}, /*#__PURE__*/React.createElement("path", {
  id: "Leg",
  className: "cls-5",
  d: "M89.83,228.1l68.94,173.83,46.25,147h18.25L152.58,228.1Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Leg-2",
  className: "cls-6",
  d: "M76,228.1c-.73,61.09-11.44,143.33-13.15,147.14Q61.08,379-55.31,472.08l12.57,13.41Q94.6,405.72,101,395.08c6.35-10.64,27-108.54,43.65-167Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pant",
  className: "cls-7",
  d: "M136.18,533.75,223,524.37,158.66,228.1H80.9Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pant-2",
  className: "cls-7",
  d: "M-37.36,450.45l57,67.15q90-97.89,104.91-127.74t26.8-161.76H63.81Q57.3,344.1,55,349.54T-37.36,450.45Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Body_Hoodie",
  "data-name": "Body Hoodie"
}, /*#__PURE__*/React.createElement("path", {
  id: "Skin",
  className: "cls-3",
  d: "M197.35,195.87l49.82,24.47Q266,222,279.28,227c2.2,1.39,5.1,4.47-2.87,5.25s-16.32,2-16.94,4.83,4.71,5.21,3.15,9.2q-1.56,4-23.92-14.41l-46.87-10.32Zm-169.22,31,28.93-5q-11.61,90.74-12.82,96.37c-1.81,8.46,7.08,19.29,11.12,25.24C46.67,349.34,45,333.61,34,341.22c-10,6.94-16.64,17.51-30.54,12-1.71-.68-4-4-.44-7.45C12,337.05,24.5,322.3,25.77,318q2.63-9,2.36-91.14Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Coat-Back",
  className: "cls-8",
  d: "M89,91.67l11.6-4.15c51.11,30.32,82.26,100.4,143.51,129.64l-10.21,18.46C137.44,240.63,98.28,155.35,89,91.67Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shirt",
  className: "cls-9",
  d: "M63.23,250.45l105.84-18.66c4.84-.86,2.7-7.65,1.38-11-15.2-39-54.39-77.12-64.55-134.73l-31.37.62C56.4,131.52,56.44,182.81,63.23,250.45Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Coat-Front",
  className: "cls-8",
  d: "M43.41,133.1q-7-.73-12.1-7C16.62,108,18.71,96.27,30,90.54s23.24-.14,42.24-3.49a19.52,19.52,0,0,1,2.87-.3l9.65-1.14q65.59,131.46,55.33,181.1l-83.3,14.68a288.16,288.16,0,0,1-9.08,31.41l-22.7,4Q3.62,214.26,43.41,133.1Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shade",
  className: "cls-10",
  d: "M66.54,230.7q9.7,32,21.15,45.24l-30.91,5.45Q61.88,259.83,66.54,230.7Z"
})))))), /*#__PURE__*/React.createElement("g", {
  className: "cls-11"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_2",
  "data-name": "Mask Group 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "humaaans_standing-8",
  "data-name": "humaaans standing-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "A-Human_Standing",
  "data-name": "A-Human Standing"
}, /*#__PURE__*/React.createElement("g", {
  id: "Head_Front_Long",
  "data-name": "Head Front Long"
}, /*#__PURE__*/React.createElement("path", {
  id: "Hair-Back",
  className: "cls-12",
  d: "M286.78,120c4.2,15.46,9.67,50.22,4.09,55.68H255.55v-.19a26.19,26.19,0,0,1-23.26-26V123.94a26.18,26.18,0,0,1,26.18-26.18h2.43A26.2,26.2,0,0,1,286.78,120Z"
}), /*#__PURE__*/React.createElement("g", {
  id: "Head-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  className: "cls-13",
  d: "M246,144.62c-5.61-6.58-9.4-14.65-8.77-23.7,1.83-26,38.1-20.32,45.15-7.17s6.22,46.51-2.9,48.86c-3.63.94-11.38-1.36-19.26-6.11l4.94,35H236Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Hair-Front",
  className: "cls-12",
  d: "M253.89,140.22c1.35,14.46.81,31-3.2,34.9H215.38c-2-34.18,17-21,17-53.13,1.19-1.16,2.31-2.3,3.42-3.29v-1Q245,99,259.07,99c14.1,0,18.54,6.56,22.33,12.13-2.83,9.72-13.82,11.16-23.6,17.22a6.7,6.7,0,1,0-4.22,11.9Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Bottom_Standing_Skirt",
  "data-name": "Bottom Standing Skirt"
}, /*#__PURE__*/React.createElement("path", {
  id: "Leg-3",
  className: "cls-13",
  d: "M289.83,436a6.43,6.43,0,0,1-.71-1.38c-3.91-10.33-66.44-121.7-72.67-142.07h70.4c4.74,15.49,26.06,112.64,29.06,132,9.46,30.57,28.95,129.6,31.44,136.46,2.62,7.22-12.11,14.73-16,5.86-6.25-14.12-21.12-53.18-27.75-77C297.36,467.51,292.3,447.4,289.83,436Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Leg-4",
  className: "cls-13",
  d: "M232.23,449.6c-28.59,7.22-133.16,20.29-140.33,22.33-7.39,2.11-13.86-13.1-4.73-16.4,14.51-5.24,54.52-17.36,78.77-22.3,19.51-4,37.32-7.23,49.27-9.13-1-33.57-5.65-114.15-2.61-131.55h62.29C272,309.24,247.39,431,242.82,443.19,241.37,447.54,237,449.46,232.23,449.6Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Skirt",
  className: "cls-14",
  d: "M212.8,292.55q41.16-11.78,77.92,0c8.52,38.89,29.23,54.32,32.87,113.93-41.39,20.57-92.53-14.67-135.14,5.39C176.28,383.82,193.32,316.25,212.8,292.55Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Body_Long-Sleeve",
  "data-name": "Body Long-Sleeve"
}, /*#__PURE__*/React.createElement("path", {
  id: "Skin-2",
  className: "cls-13",
  d: "M330.89,244.24,379,237.68q14.43-8,26.54-10.87c2.27-.06,5.89.76.5,5.25s-10.85,9.46-9.89,11.86,6,1.5,6.8,5.19q.81,3.67-24.39,1.2l-39,15.46Zm-151,11.12,26.66.1q-43.86,98.68-45.73,103.33c-2.81,7,3.15,17.62,5.7,23.33-8.3,3.71-7.42-10-17.89-5.17-9.56,4.45-16.84,12.51-27.88,5.69-1.36-.84-2.85-4,.75-6.46,9-6.14,21.86-16.89,23.61-20.43q3.57-7.23,34.78-100.39Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clothes-Back",
  className: "cls-15",
  d: "M252.91,170.81l20.88,1.39c5.14,46.51,33.14,75.89,95.83,65.94L378,298c-58.59,7.58-110-15.88-120.51-79.4C254.71,202.19,252.56,185.08,252.91,170.81Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Clothes",
  className: "cls-16",
  d: "M242.62,164.74,274.24,172c0,54.4,17.33,89.1,26.22,129.1H215.05q-1.8,20.73-2.33,42.61h-64q21.75-115.66,91.77-179h2.07Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shade-2",
  className: "cls-10",
  d: "M228.52,223.48q-3.3,50.84,3.88,77.6H215.05c2.38-27.38,6.58-53.25,13.47-77.6Z"
})))))), /*#__PURE__*/React.createElement("g", {
  className: "cls-17"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_3",
  "data-name": "Mask Group 3"
}, /*#__PURE__*/React.createElement("g", {
  id: "humaaans_standing-20",
  "data-name": "humaaans standing-20"
}, /*#__PURE__*/React.createElement("g", {
  id: "humaaan-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Head_Front_Hijab2",
  "data-name": "Head Front Hijab2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Head-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  className: "cls-6",
  d: "M339,202.94c-5.14-5.24-8.83-11.84-8.83-19.53,0-22.15,31-19.46,37.78-8.75s8,39,.45,41.52c-3,1-9.71-.48-16.67-4L358,241.51l-24.73,1.74Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Bottom_Standing_Sprint",
  "data-name": "Bottom Standing Sprint"
}, /*#__PURE__*/React.createElement("path", {
  id: "Leg-5",
  className: "cls-6",
  d: "M319.47,329.88c3.63,25.23,128.52,91.54,129.37,93.59q.56,1.36-31.1,90.88l10.74,3.34Q480,421.63,476.27,412,471,398.26,377,326.11Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pant-3",
  className: "cls-18",
  d: "M419.57,501.08l17.52,5c33.19-43.15,45-77.67,41.2-94.57q-3.77-16.9-99-85.76l-61,4.25c6.17,58.59,120.15,94.4,121.81,96.8S428.82,454.74,419.57,501.08Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Leg-6",
  className: "cls-5",
  d: "M333.19,328.9,288.85,460.62,244,572.5l12.37-.87L375.09,326Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pant-4",
  className: "cls-18",
  d: "M247.2,549.69,275,552.92c19.05-32.72,99-167,104.52-227.27l-61.15,4.29C288.87,375.31,265.22,516.53,247.2,549.69Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Body_Pointing-Up",
  "data-name": "Body Pointing-Up"
}, /*#__PURE__*/React.createElement("path", {
  id: "Skin-3",
  className: "cls-6",
  d: "M411.74,217.25,450,202.79a88.34,88.34,0,0,1,19.74-13.89c1.85-.48,5-.5,1.39,4.18s-7.12,9.77-5.88,11.54,5.18.09,6.55,2.94q1.38,2.83-19.79,5.6l-29.11,20Zm1.38,69.09,34.55,21.83a88.71,88.71,0,0,1,23,7.41c1.5,1.19,3.4,3.68-2.49,3.64s-12.09.18-12.76,2.24,3,4.2,1.6,7q-1.44,2.82-16.39-12.43l-33.49-11.22Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Coat-Back-2",
  className: "cls-19",
  d: "M357.51,224.93c20.24,32.12,47.91,55.89,87.29,79.87l-13.09,17c-43-12.64-65.75-20.48-78.82-51.26-3.27-7.72-6.94-32.81-9.5-46Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shirt-2",
  className: "cls-20",
  d: "M315.28,339.62l79.33-5.57q-32.73-80.31-35.45-110.91c-.1-1-2.15-2.74-3-2.44q-9.15,3.3-20.11-.57C319.38,251.7,315.49,289.39,315.28,339.62Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Coat-Front-2",
  className: "cls-19",
  d: "M342.84,219.71c22.75-1.41,59.94.15,101.53-16.49L450,223.91c-30.71,22.94-62.15,41.25-90.84,41,16.12,52.27,18.6,95.82-8.75,97.74l-42.3,3c-9.89-44.68,3.38-108.52,17.53-141.24a5.6,5.6,0,0,1,4.85-3.84l12.29-.86Z"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "humaaans_sitting-8",
  "data-name": "humaaans sitting-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "A-Human_Sitting",
  "data-name": "A-Human Sitting"
}, /*#__PURE__*/React.createElement("g", {
  id: "Head_Front_Short-2",
  "data-name": "Head Front Short-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Hair-2",
  className: "cls-12",
  d: "M335.2,201.94c-3-13.4-11.6-22.54-10.29-28.53a9.09,9.09,0,0,1,7-7.45q2.94-11.88,18.93-10.1c16,1.77,25.77,8.42,21.55,23-3.87,0-8.55-1.4-15,1-2.08.76-3.56,3.14-4.42,7.14h-2.92q-4.26-7.06-8.4-5.19c-2.77,1.25-3.39,4.28-1.89,9.09l-1.44,11Z"
})))))));

var SvgFamily = function SvgFamily(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 475.31 383.94",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFamily, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Family.562fa90c.svg";
export { ForwardRef as ReactComponent };